import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import {ErrorBoundaryApp} from "./components/ErrorBoundaryHandler/ErrorBoundaryApp";
import "./index.css";
import {useThemeStore} from "./store/useTheme.store";

import "./Infra/lang/index.js";

useThemeStore.getState().initTheme();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ErrorBoundaryApp>
      <App />
    </ErrorBoundaryApp>
  </React.StrictMode>
);
